import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReleaseOfUnwantedCnaeComponent } from './release-of-unwanted-cnae.component';
import { FdFormComponentsModule } from '../shared/fd-form-components/fd-form-components.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddOrEditReleaseOfUnwantedCnaeComponent } from './components/add-or-edit-release-of-unwanted-cnae/add-or-edit-release-of-unwanted-cnae.component';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ListReleaseOfUnwantedCnaeComponent } from './components/list-release-of-unwanted-cnae/list-release-of-unwanted-cnae.component';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { CpfCnpjPipe } from '../shared/pipes/cpf-cnpj.pipe';
import { PipesModule } from '../shared/pipes/pipes.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTooltipModule } from '@angular/material/tooltip';
import { faEdit, faInfoCircle, faMoneyCheckAlt, faPlusCircle, fas, faTrash } from '@fortawesome/free-solid-svg-icons';
import { AuditReleaseOfUnwantedCnaeComponent } from './components/audit-release-of-unwanted-cnae/audit-release-of-unwanted-cnae.component';



@NgModule({
  declarations: [
    ReleaseOfUnwantedCnaeComponent,
    AddOrEditReleaseOfUnwantedCnaeComponent,
    ListReleaseOfUnwantedCnaeComponent,
    AuditReleaseOfUnwantedCnaeComponent
  ],
  imports: [
    CommonModule,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    FdFormComponentsModule,
    FlexLayoutModule,
    MatDialogModule,
    MatPaginatorModule,
    MatTableModule,
    MatTooltipModule,
    MatFormFieldModule,
    PipesModule
  ],
  providers: [CpfCnpjPipe]
})
export class ReleaseOfUnwantedCnaeModule {
  constructor(library: FaIconLibrary) {
    library.addIconPacks(fas)
    library.addIcons(faEdit, faMoneyCheckAlt, faPlusCircle, faTrash, faInfoCircle);
  }
 }
